export default "__VITE_ASSET__W7NT2CbY__"